module.exports = __webpack_public_path__ + "static/img/collect.c9609302.png";